// utils/nombreCorto.js
//
// Nombre corto para las pantallas que ve el solicitante: primer nombre + primer
// apellido. Oculta el nombre completo de los agentes por seguridad; entre staff
// (agentes, líderes, admin) los nombres se muestran completos.
//
// Heurística: asume que los dos últimos tokens son los apellidos (formato del
// padrón del intranet: "NOMBRE1 [NOMBRE2] APELLIDO1 APELLIDO2"), así que toma el
// primer token como nombre y el penúltimo como primer apellido. Con dos o menos
// tokens se muestra tal cual.
export function nombreCorto(nombre) {
    const p = String(nombre || '').trim().split(/\s+/).filter(Boolean);
    if (p.length <= 2) return p.join(' ');
    return `${p[0]} ${p[p.length - 2]}`;
}

// Roles que ven los nombres completos (staff). Admin light firma como 'admin'.
const ROLES_STAFF = new Set(['admin', 'agent', 'leader']);
export const esStaff = (role) => ROLES_STAFF.has(role);

// Nombre que debe ver `viewerRole` de una persona con rol `personaRole`.
// Staff ve todo completo. Un solicitante/autorizador ve acortado el nombre de
// cualquier persona interna (agente, líder, admin, autorizador); los nombres de
// otros solicitantes (role 'user') se muestran completos. Si no se conoce el rol
// de la persona (p. ej. assignedTo solo trae `name`) se asume que es interna.
export function nombreVisible(nombre, viewerRole, personaRole) {
    if (!nombre) return nombre;
    if (esStaff(viewerRole)) return nombre;
    if (personaRole === 'user') return nombre;
    return nombreCorto(nombre);
}
